import * as React from "react";
import { useState } from "react";
import { useBindings } from "~/hooks/use-bindings.ts";
import ContributionMeter from "~/components/contribution-meter.tsx";

export const PageContribute = ({ children }: { children: React.ReactNode }) => {
  const contributionTotal = useBindings().contributionTotal;

  const [open, setOpen] = useState("" as string);

  const toggleQuestion = (e: React.MouseEvent<HTMLDivElement>) => {
    if (open === e.currentTarget.dataset.question) {
      setOpen("");
    } else {
      setOpen(e.currentTarget.dataset.question || "");
    }
  };

  return (
    <div className="PageContribute">
      <div className="PageContribute__Top">
        <div className="container --1200">
          <div className="row">
            <div className="--span-12 PageContribute__HeadingContainer">
              <h1 className="PageContribute__Heading">The TPM Journalism&nbsp;Fund</h1>
              <h1 className="PageContribute__SubHeading">Help Us Prepare For What’s Next</h1>

              <div className="PageContribute__TickerContainer">
                <ContributionMeter total={contributionTotal || 97000} goal={500000} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="PageContribute__Middle">
        <div className="container --1200">
          <div className="PageContribute__Flex">
            <div className="PageContribute__Left">
            </div>
            <div className="PageContribute__FormContainer">
              <div className="PageContribute__Form">
                {children}
              </div>
            </div>
            <div className="PageContribute__FAQ">
              <div className="PageContribute__FAQHeading">Frequently Asked Questions</div>

              <div
                onClick={(e) => toggleQuestion(e)}
                data-question="question1"
                className={`PageContribute__Question question1 ${
                  open === "question1" ? "--open" : ""
                }`}
              >
                <p className="question">
                  What is the TPM Journalism Fund?&nbsp;<span className="angle-down">
                    <i className="fal fa-chevron-down" />
                  </span>
                </p>
                <p className="answer">
                  TPM is a member-funded journalism organization. Advertising now accounts for less
                  than 10 percent of revenue. This is a good thing, but it means we need and rely on
                  funding from our members and our readers. While a membership is definitely the
                  best way to support TPM, we know that some members wish they could contribute
                  more. We also know there are readers who are not members, yet wish to support us
                  in some way. The TPM journalism Fund is an avenue to do so.
                </p>
              </div>

              <div
                onClick={(e) => toggleQuestion(e)}
                data-question="question2"
                className={`PageContribute__Question question2 ${
                  open === "question2" ? "--open" : ""
                }`}
              >
                <p className="question">
                  Why contribute?&nbsp;<span className="angle-down">
                    <i className="fal fa-chevron-down" />
                  </span>
                </p>
                <p className="answer">
                  The simple answer is that it helps TPM get better. The more contributions we
                  receive, the more journalists we can hire and the more reporting we can do on a
                  growing list of critical issues. Equally important, contributions allow us to make
                  our journalism more accessible. While putting some of our journalism behind a
                  paywall has become a necessary business strategy, we want to ensure that our
                  reporting can be read by anyone, regardless of financial status. Contributing to
                  The TPM Journalism Fund makes that possible by funding our community and student
                  membership programs.
                </p>
              </div>

              <div
                onClick={(e) => toggleQuestion(e)}
                data-question="question3"
                className={`PageContribute__Question question3 ${
                  open === "question3" ? "--open" : ""
                }`}
              >
                <p className="question">
                  How is the money spent?&nbsp;<span className="angle-down">
                    <i className="fal fa-chevron-down" />
                  </span>
                </p>
                <p className="answer">
                  Contributions fund everything that goes into employing our unionized team of
                  journalists from salary to benefits. And for every $60 of contributions we
                  receive, we provide one free Prime membership to a student or TPM community
                  member. Since 2013, contributions have provided thousands of Community-Supported
                  and Student memberships. If you're interested in learning more about where the
                  money goes,{" "}
                  <a href="https://talkingpointsmemo.com/about#financials">
                    check out our financials page
                  </a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageContribute;
